import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=6ee18a55&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=6ee18a55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee18a55",
  null
  
)

export default component.exports